export default __webpack_public_path__ + "static/media/ic_equity_24.da5bbbce.svg";